<template>
  <div class="dea-school-selected">
    <div class="dea-school-selected__school-data">
      <SchoolData :name="name" :code="code" :address="address" :label="label" />
      <Badge v-if="leadingSchool" class="dea-bg-black">Scuola Polo</Badge>
      <ul class="dea-school-selected__chips-list">
        <li v-for="(item, i) in chips" :key="i" class="dea-school-selected__chips-list__item">
          <Chips class="dea-school-selected__chip">{{ item.label }}</Chips>
        </li>
      </ul>
    </div>
    <div class="dea-school-selected__cta-container">
      <Links
        class-name="dea-links dea-links--pointer dea-links--target-color-blue-docenti dea-links--large"
        @click="$emit('modify-school')"
      >
        Modifica
      </Links>
      <Links
        class-name="dea-links dea-links--pointer dea-links--target-color-blue-docenti dea-links--large"
        @click="$emit('delete-school')"
      >
        Rimuovi scuola
      </Links>
    </div>
  </div>
</template>

<script>
import Badge from "../elements/Badge";
import Chips from "../elements/Chips";
import Links from "../elements/Links";
import SchoolData from "../elements/SchoolData";

export default {
  name: "SchoolSelected",
  components: { Badge, Chips, Links, SchoolData },
  props: {
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    chips: {
      type: Array,
      default: () => [],
    },
    leadingSchool: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
